import React from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { Menu, Tab, TabPane } from 'semantic-ui-react'
import { RouteTypes } from '~/routes/constants'
import { Link } from 'react-router-dom'
import Router from './Filters/Router'

const IndividualFilters: React.FC = () => {
  const { t } = useTranslation()

  const panes = [
    {
      menuItem: t('General filter'),
      route: RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GENERAL,
      key: 'general'
    },
    {
      menuItem: t('Geographical filter'),
      route: RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GEOGRAPHICAL,
      key: 'geographical'
    },
    {
      menuItem: t('Amount filter'),
      route: RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT,
      key: 'amount'
    },
    {
      menuItem: t('Radius'),
      route: RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS,
      key: 'radius'
    }
  ]

  function isTabActive(index, route) {
    return index === 0 && location.pathname === RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS ? true : location.pathname.includes(route)
  }

  function renderRoutes() {
    return <Router />
  }

  function renderPanes() {

    return <Tab
      menu={{ secondary: true, pointing: true }}
      panes={panes.map((pane, index) => {
        return {
          menuItem: <Menu.Item
            as={Link}
            key={pane.key}
            active={isTabActive(index, pane.route)}
            to={pane.route}
          >{pane.menuItem}</Menu.Item>,
          pane: <TabPane
            active={isTabActive(index, pane.route)}
            style={{ border: 'none' }}
            key={pane.key}
          />
        }
      })}
    />
  }

  return <Layout
    title={t('Individual filters')}
    useSpinner
    childContainerSize={'450px'}
  >
    {renderPanes()}
    {renderRoutes()}
  </Layout>
}
export default IndividualFilters